<template>
    <v-dialog
        v-model="dialog"
        :max-width="dialog_width"
        :persistent="loading"
    >
        <div class="tw-flex tw-flex-col side-site-padding tw-gap-2">
            <h2 class="tw-capitalize tw-text-secondary tw-text-center">
                Delete Canada Life Data Feed
            </h2>
            <div class="pb-0">
                <v-form name="deletePreviewLondonLifeForm" ref="deletePreviewLondonLifeForm">
                    <div class="tw-flex tw-w-full tw-mb-2 tw-p-2">
                        <date-picker
                            display-label="Transfer Date"
                            v-model="transferDate"
                            show-adjacent-months
                            class="tw-w-full"
                            dense
                            :rules="[rules.required]"
                            hide-details="auto"
                        />
                    </div>
                </v-form>
            </div>

            <div class="tw-flex tw-flex-row tw-justify-center tw-gap-3">

                <v-btn
                    text
                    @click="cancelDialog"
                    class="btn-solid"
                >
                    Cancel
                </v-btn>
                <v-btn
                    text
                    @click="requestExportExecution"
                    class="main-btn"
                    :loading="loading"
                >
                    Preview
                </v-btn>
                <v-btn
                    text
                    @click="requestDeleteExecution"
                    class="main-btn"
                    :loading="loading"
                >
                    Delete
                </v-btn>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DatePicker from "@/Generic/DatePicker.vue";
export default {
    name: "DeleteLondonLifeDataFeedModal",
    components: {DatePicker},
    props: {
        'value': {
            // The visibility of the dialog.  To be used with `v-model`
            type: Boolean,
            required: true
        },
        'constants': {
            // The constants we will rely on
            type: Object,
            required: false
        },
        'valuelists': {
            // The constants we will rely on
            type: Object,
            required: false
        },
        'export_filename': {
            // This determines the name of the file that gets exported
            type: String,
            required: false,
            default: function () {
                return 'preview-london-life-data-feed-export.xlsx'
            }
        },
    },
    data() {
        return {
            dialog: this.value || false,
            loading: false,
            filter: this.filters,
            exportFilename: this.export_filename,
            transferDate: null,
            rules: {
                required: value => !!value || 'Required',
            },
        }
    },
    mounted() {
        //
    },
    computed: {
        dialog_width() {
            return '500px'
        },
    },
    methods: {
        cancelDialog() {
            if (!this.loading) {
                this.dialog = false
            }
        },
        async requestExportExecution() {
            if (this.$refs.deletePreviewLondonLifeForm.validate()) {
                axios({
                    url: route('members.export-london-life'),
                    method: 'post',
                    data: this.$data,
                    onUploadProgress: (evt) => {
                        this.loading = !this.loading
                    },
                    onDownloadProgress: (evt) => {
                        this.loading = !this.loading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            if (response.data.warning) {
                                this.$root.snackbar.warning(response.data.warning)
                            } else {
                                this.$root.snackbar.success(`You will receive an email to ${this.$page.user?.email} with the preview once it is done.`)
                                this.loading = false
                                this.dialog = false
                            }
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                        } else {
                            this.$root.snackbar.error(error)
                        }
                        this.loading = false
                    })
                this.loading = false
            }
        },
        async requestDeleteExecution() {
            if (this.$refs.deletePreviewLondonLifeForm.validate()) {
                axios({
                    url: route('members.delete-london-life'),
                    method: 'post',
                    data: this.$data,
                    onUploadProgress: (evt) => {
                        this.loading = !this.loading
                    },
                    onDownloadProgress: (evt) => {
                        this.loading = !this.loading
                    },
                })
                    .then(response => {
                        if (response.data.success) {
                            if (response.data.warning) {
                                this.$root.snackbar.warning(response.data.warning)
                            } else {
                                this.$root.snackbar.success(`${response.data.amountDeleted} Canada life records have been deleted`)
                                this.loading = false
                                this.dialog = false
                            }
                        } else {
                            throw (response.data.error)
                        }
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                        } else {
                            this.$root.snackbar.error(error)
                        }
                        this.loading = false
                    })
                this.loading = false
            }
        },
    },
    watch: {
        value(newInput, oldInput) {
            this.dialog = newInput
        },
        dialog(newDialog, oldDialog) {
            this.$emit('input', newDialog)
            if (newDialog === false) {
                // Closing modal
            } else {
                // Opening modal
            }
        },
    },
}

</script>

<style scoped>

</style>
